import clsx from 'clsx';
import {
    GlowButton,
    GlowButtonProps,
    GlowIcon,
    GlowIconProps,
    Icons,
    PropsWithAriaLabel,
    PropsWithClassName,
} from '@headless-workspace/glow-ds';
import { Component } from '@headless-workspace/typings';

type UICarouselNavigationButtonProps = PropsWithClassName &
    PropsWithAriaLabel & {
        type: 'prev' | 'next';
        onClick: () => void;
        disabled: boolean;
        iconType?: GlowIconProps['type'];
        variant?: GlowButtonProps['variant'];
        size?: GlowButtonProps['size'];
    };

export const UICarouselNavigationButton: Component<UICarouselNavigationButtonProps> = ({
    className,
    ariaLabel,
    type,
    onClick,
    disabled,
    iconType = 'medium',
    variant = 'primary',
    size = 'large',
}) => {
    'use memo';

    return (
        <GlowButton
            className={className}
            onClick={onClick}
            disabled={disabled}
            Icon={() => (
                <GlowIcon Icon={Icons.ChevronRight} className={clsx(type === 'prev' && 'rotate-180')} type={iconType} />
            )}
            ariaLabel={ariaLabel}
            variant={disabled ? 'disabled' : variant}
            size={size}
        />
    );
};
